import { CustomerViewModel } from "src/app/view-models/orders/customer.view-model";
import { StoredCustomer } from "../models/stored-orders/stored-customer";
import { IStoredMapper } from "./stored-mapper";

/**
 * Mapping class that maps between Customer view model and database StoredCustomer.
 */
export class CustomerMapper implements IStoredMapper<CustomerViewModel, StoredCustomer> {
	/**
	 * Maps a Customer to a StoredCustomer.
	 * @param customer The customer data to convert.
	 * @returns A StoredCustomer object.
	 */
	public ToStored(customer: CustomerViewModel): StoredCustomer {
		return {
			Name: customer.Name,
			Terminal: customer.Terminal
		};
	}

	/**
	 * Maps a StoredCustomer to a Customer.
	 * @param storedCustomer The stored customer data to convert.
	 * @returns A Customer object.
	 */
	public FromStored(storedCustomer: StoredCustomer): CustomerViewModel {
		return {
			Name: storedCustomer.Name,
			Terminal: storedCustomer.Terminal
		};
	}
}